import { AppPhase, GradingMode, type Assignment, type Course } from '../types';

/** Inputs needed to decide where “Scan now / Start grading” should go. */
export type FastScanResolutionInput = {
  cameraFirstLaunch: boolean;
  selectedCourse: Course | null;
  selectedAssignment: Assignment | null;
  customRubric: string;
  gradingMode: GradingMode | null;
};

export type FastScanResolution =
  | { action: 'phase'; phase: AppPhase }
  | { action: 'start'; mode: GradingMode };

/**
 * Single decision tree for the grade dashboard primary action (fast scan).
 * Preserves prior behavior: when camera-first is off, always open mode selection first.
 */
export function resolveFastScanStep(input: FastScanResolutionInput): FastScanResolution {
  const { cameraFirstLaunch, selectedCourse, selectedAssignment, customRubric, gradingMode } =
    input;
  const hasRubric = customRubric.trim().length > 0;

  if (!cameraFirstLaunch) {
    return { action: 'phase', phase: AppPhase.MODE_SELECTION };
  }
  if (!selectedCourse) {
    return { action: 'phase', phase: AppPhase.GRADE_COURSE_PICKER };
  }
  if (!selectedAssignment) {
    return { action: 'phase', phase: AppPhase.ASSIGNMENT_SELECT };
  }
  if (!hasRubric) {
    return { action: 'phase', phase: AppPhase.RUBRIC_SETUP };
  }
  if (gradingMode) {
    return { action: 'start', mode: gradingMode };
  }
  return { action: 'phase', phase: AppPhase.MODE_SELECTION };
}
